/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as ActionTypes from "constants/ActionTypes";
import {
  SetPlayerPlaybackProgressAction,
  SetPlayerState,
} from "reducers/PlayerReducer";
import { SetShowVideoPreviewAction, SetStreamingAction } from "types/Actions";
import { PlayerStateWithBuffering } from "types/Player";

export function setPlayerState(
  newState: PlayerStateWithBuffering
): SetPlayerState {
  return {
    type: ActionTypes.SET_PLAYER_STATE,
    state: newState,
  };
}

export function setPlayerPlaybackProgress(
  currentTime: number,
  duration: number
): SetPlayerPlaybackProgressAction {
  return {
    type: ActionTypes.SET_PLAYER_PLAYBACK_PROGRESS,
    currentTime: Math.round(Math.min(currentTime, duration)),
    duration: Math.round(duration),
  };
}

export const setStreaming = (streaming: boolean): SetStreamingAction => ({
  type: ActionTypes.SET_STREAMING,
  payload: streaming,
});

export const setShowVideoPreview = (
  showVideoPreview: boolean
): SetShowVideoPreviewAction => ({
  type: ActionTypes.SET_SHOW_VIDEO_PREVIEW,
  payload: showVideoPreview,
});
